import { removeUnallowedFields } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { SipIdentityExtensionUpdateFields } from '@ragu-components/ord-types';

import type { ResourceCallbacks } from 'react-admin';

export const sipIdentityCallbacks: ResourceCallbacks = {
  resource: Resources.sip_identities,
  beforeSave: async (record: object) => removeUnallowedFields(SipIdentityExtensionUpdateFields, record),
};
